/*!
 * Serialize all form data into a query string
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Node}   form The form to serialize
 * @return {String}      The serialized form data
 */

/**
 * @param {HTMLOptionElement} option
 * @return {null|number|string}
 */
function selectedMultiSelectOptions(option) {
  if (!option.selected) {
    return null;
  }

  return option.value;
}

function fieldAllowed(field) {
  return !(
    !field.name
    || field.disabled
    || field.type === 'file'
    || field.type === 'reset'
    || field.type === 'submit'
    || field.type === 'button'
  );
}

/**
 * @param {object} field
 * @return {Array}
 */
function handleFormElement(field) {
  const items = [];

  // Don't serialize fields without a name, submits, buttons, file
  // and reset inputs, and disabled fields
  if (!fieldAllowed(field)) {
    return [];
  }

  // If a multi-select, get all selections
  if (field.type === 'select-multiple') {
    for (let n = 0; n < field.options.length; n += 1) {
      const optionValue = selectedMultiSelectOptions(field.options[n]);

      if (optionValue) {
        const key = encodeURIComponent(field.name);
        const value = encodeURIComponent(field.options[n].value);

        items.push([key, value]);
      }
    }
  } else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
    const key = encodeURIComponent(field.name);
    const value = encodeURIComponent(field.value);

    items.push([key, value]);
  }

  return items;
}

export default (form, toObject = false) => {
  const serialized = [];
  const serializedObject = {};

  // Loop through each field in the form
  for (let i = 0; i < form.elements.length; i += 1) {
    const field = form.elements[i];

    const formFieldData = handleFormElement(field);

    formFieldData.forEach((item) => {
      const [key, value] = item;

      if (toObject) {
        serializedObject[key] = value;
      } else {
        serialized.push(`${key}=${value}`);
      }
    });
  }

  if (toObject) {
    return serializedObject;
  }

  return serialized.join('&');
};
